const baseURL =
	process.env.NODE_ENV !== 'production'
		? 'http://localhost:3001/api'
		: process.env.REACT_APP_TEST
			? 'https://test.energy-monitor.eu/api'
			: 'https://app.energy-monitor.eu/api'

module.exports = {
	baseURL
}
